<template>
	<div class="sk_objects_user_help">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">API概述</h1>
		<h3 class="doc_main_h3">
			接口列表
		</h3>
		<div class="table_box">
			<template>
			    <el-table
				    :data="tableDataInterface"
				    :span-method="objectSpanMethodInterface"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="type"
					        label="类别">
				      	</el-table-column>
				      	<el-table-column
				        	prop="name"
				        	label="名称">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
				      	<el-table-column
				        	prop="api"
				        	label="API">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.index}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
		<h3 class="doc_main_h3">
			请求参数
		</h3>
		<div class="table_box">
			<template>		<!--:span-method="objectSpanMethod"-->
			    <el-table
				    :data="tableDataParameter"
				    :span-method="objectSpanMethodParameter"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="是否必填">
				      	</el-table-column>
				      	<el-table-column
				        	prop="key"
				        	label="参数名">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.index}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
				      	<el-table-column
				        	prop="type"
				        	label="类型">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="说明">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
		<h3 class="doc_main_h3">
			协议头部
		</h3>
		<div class="table_box">
			<template>		<!--:span-method="objectSpanMethod"-->
			    <el-table
				    :data="tableDataHead"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="参数名">
				      	</el-table-column>
				      	<el-table-column
				        	prop="type"
				        	label="类型">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="说明">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.index}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
		<h3 class="doc_main_h3">
			通用错误码
		</h3>
		<div class="table_box">
			<template>		<!--:span-method="objectSpanMethod"-->
			    <el-table
				    :data="tableDataErrorCode"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="状态代码"
					        width="110px">
				      	</el-table-column>
				      	<el-table-column
				        	prop="type"
				        	label="错误信息"
				        	width="230px">
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="说明">
				        	<template scope="scope">
					    		<div class="table_msg">	
					    			<div class="table_msg_list" v-for="item in scope.row.msg">
					    				{{item}}
					    			</div>
					    		</div>
					    	</template>
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
		
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['物体识别','SKObjects-API','API概述'],
				tableDataParameter:[//请求参数表
					{
						"code":"必须",
						"key":"api_key",
						"type":"String",
						"msg":"调用次API的API Key",
						"rowspan":1,
						"colspan":1,
					},
					{
						"code":"必须",
						"key":"api_secret",
						"type":"String",
						"msg":"调用此API的API Secret",
						"rowspan":1,
						"colspan":1,
					},
					{
						"code":"二选一",
						"key":"image_url",
						"type":"String",
						"msg":"图片的URL",
						"rowspan":2,
						"colspan":1,
					},
					{
						"code":"二选一",
						"key":"api_secret",
						"type":"String",
						"msg":"图片数据",
					},
				],
				tableDataHead:[//头部协议
					{
						"code":"Authorization",
						"type":"String",
						"msg":"有效签名串，用于鉴权",	
					},
				],
				tableDataErrorCode:[//通用错误码
					{
						"code":"10001",
						"type":"AUTHORIZATION_ERROR<reason>	",
						"msg":[
								"api_key没有调用本API的权限，目前的<reason>有：",
								"APP_ID_NOT_EXISTED：app_id不存在",
								"API_KEY_NOT_EXISTED：api_key不存在",
								"API_KEY_INVALID：api_key无效",
								"API_SECRET_NOT_EXISTED：api_secret不存在 ",

								"CFG_NOT_EXISTED：签名不存在",
								"SERVICE_PARAM_NOT_EXISTED：service参数不存在 ",
								"CFG_NOT_MATCH：签名不匹配",
								"SERVICE_NOT_AUTH：没有权限使用该服务",
								"USER_BAN_USE_API_KEY：用户自己禁止该api_key调用（暂时没有）",

								"ADMIN_BAN_USE_API_KEY：管理员禁止该api_key调用（暂时没有）",
								"BALANCE_NOT_ENOUGH：由于账户余额不足禁止调用（暂时没有）",
								"VISIT_COUNT_NOT_ENOUGH：访问量不足",
								"AUTHENTICATION_INFO_WRONGFUL：鉴权信息（签名等信息）不合法，禁止访问",
							  ]	
					},
					{
						"code":"10002",
						"type":"NETWORK_REQUEST_TIMEOUT",
						"msg":[
								"网络请求超时",
							  ]	
					},
					{
						"code":"10003",
						"type":"CONCURRENCY_LIMIT_EXCEEDED",
						"msg":[
								"并发数超过限制",
							  ]	
					},
					{
						"code":"10004",
						"type":"TOO_MANY_REQUEST_RATE_ERROR",
						"msg":[
								"请求超过频率限制",
							  ]	
					},
					{
						"code":"10005",
						"type":"MISSING_REQUIRED_ARGUMENTS: <key>",
						"msg":[
								"缺少必选参数，若是多个用逗号“,”隔开（<key1,key2>）",
							  ]	
					},
					{
						"code":"10006",
						"type":"ARGUMENTS_PARSE_ERROR:<key>",
						"msg":[
								"某个参数解析出错（参数必须是数字，但是输入的是非数字，识别服务名称有误，参数长度过长,...）",
							  ]	
					},
					{
						"code":"10007",
						"type":"COEXISTENCE_ARGUMENTS_ERROR",
						"msg":[
								"同时传入了要求是N选一的参数，如有特殊说明则不返回该错误。",
							  ]	
					},
					{
						"code":"10008",
						"type":"REQUEST_IMAGE_TOO_SMALL",
						"msg":[
								"发送的图片宽或者高小于64px",
							  ]	
					},
					{
						"code":"10009",
						"type":"REQUEST_IMAGE_TOO_LARGE",
						"msg":[
								"发送的图片数据过大，需压缩",
							  ]	
					},
					{
						"code":"10010",
						"type":"AUTHORIZATION_ERROR<reason>	",
						"msg":[
								"服务器内部错误，当此类错误发生时请再次请求，如果持续出现此类错误，请及时联系我们平台的技术支持团队,予以技术支持，目前的<reason>有：",
								"SERVICE_UNAVAILABLE：服务不可用",
								"SERVICE_TIMEOUT：后端服务超时",
								"SERVICE_DOMAINNAME_ERROR：域名解析错误",
								"SERVICE_RECV_ERROR：接收数据错误",
								"UNKNOWN_ERROR：未知错误",
							  ]	
					},
					{
						"code":"10011",
						"type":"UNSUPPORTED_IMAGE_FORMAT_ERROR:<param>	",
						"msg":[
								"图像无法正确解析，有可能不是一个图像文件、或有数据破损，param：具体参数（image_url、image_data、image_url1.image_url2）",
							  ]	
					},
					{
						"code":"10012",
						"type":"IMAGE_DOWNLOAD_TIMEOUT_ERROR",
						"msg":[
								"获取URL所指向的图片超时",
							  ]	
					},
					{
						"code":"10013",
						"type":"INVALID_IMAGE_URL_ERROR",
						"msg":[
								"图片URL无效",
							  ]	
					},
					{
						"code":"10014",
						"type":"PARAMETER_EMPTY_ERROR<key>",
						"msg":[
								"参数为空,key：具体是某个参数",
							  ]	
					},
					{
						"code":"10015",
						"type":"IMAGE_EMPTY_ERROR",
						"msg":[
								"IMAGE_EMPTY_ERROR",
							  ]	
					},
					{
						"code":"10016",
						"type":"STORAGE_ERROR",
						"msg":[
								"存储错误",
							  ]	
					},
					{
						"code":"10017",
						"type":"CACHE_ERROR",
						"msg":[
								"缓存错误",
							  ]	
					},
					{
						"code":"10018",
						"type":"IMAGE_FUZZY_DETECT_FAILED_ERROR",
						"msg":[
								"图片模糊度检测失败",
							  ]	
					},
					{
						"code":"10019",
						"type":"NO_RECOGNITION_RESULT",
						"msg":[
								"识别结果为不认识",
							  ]	
					},
					{
						"code":"10020",
						"type":"API_NOT_FOUND",
						"msg":[
								"所调用的API不存在",
							  ]	
					},
				],
				tableDataInterface:[//接口列表
					{
						"type":"物体识别",
						"name":"常见物体识别",
						"api":"https://api.sk-ai.com/objects/",	
						"rowspan":5,
						"colspan":1,
					},
					{
						"type":"物体识别",
						"name":"水果识别",
						"api":"https://api.sk-ai.com/fruits/",	
					},
					{
						"type":"物体识别",
						"name":"植物识别",
						"api":"https://api.sk-ai.com/plant/",	
					},
					{
						"type":"物体识别",
						"name":"酒品识别",
						"api":"https://api.sk-ai.com/wine/",	
					},
					{
						"type":"物体识别",
						"name":"饮料识别",
						"api":"https://api.sk-ai.com/beverage/",	
					},
				]
			}
		},
		watch:{

		},
		methods:{
			//请求参数
			objectSpanMethodParameter({ row, column, rowIndex, columnIndex }){
				if (columnIndex === 0) {
			        if (row.rowspan) {
			            return {
			              rowspan: row.rowspan,
			              colspan: row.colspan
			            };
			        } else {
			            return {
			              rowspan: 0,
			              colspan: 0
			            };
			        }
		        }	
			},
			//接口列表
			objectSpanMethodInterface({ row, column, rowIndex, columnIndex }){
				if (columnIndex === 0) {
			        if (row.rowspan) {
			            return {
			              rowspan: row.rowspan,
			              colspan: row.colspan
			            };
			        } else {
			            return {
			              rowspan: 0,
			              colspan: 0
			            };
			        }
		        }	
			},
		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sk_objects_user_help{
		//margin:5px 0 30px 30px;
		.table_box{
			width:900px;
			margin:10px 0;
		}
		thead{
			tr{
				th{
					padding:15px 0;
					background: #F5F7FA;
					color:#333;
				}
			}
			
		}
		.cell{
			text-align: center;
			color:#2c3e50;;
			.table_msg{
				text-align: left;
				.table_msg_list{
					padding: 2px 0;
				}
			}
		}
		tbody{
			td{
				padding:8px 0;
			}
		}	
		
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skobjectsapi/SKObjectsUserHelp.vue